import React from 'react';
import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';

import { UnderageInfo } from '../../../../types/underageUser';
import { AvatarPic, ContentTitle, ContentInfo, DisplayEmail } from './styles';
import svgFamilia from '../../../../static/img/familia.svg';

type BoxUnderageInfoProps = {
  info: UnderageInfo;
};

export default function BoxUnderageInfo({ info }: BoxUnderageInfoProps) {
  window.dataLayer = window.dataLayer || [];

  const title = 'Familiar responsável';
  const describeTitle =
    'Veja quem é responsável pelo controle de sua Conta Globo';

  return (
    <>
      <Box title={title} describeTitle={describeTitle}>
        <Content>
          <ContentTitle>
            <AvatarPic aria-hidden src={svgFamilia} alt="icone-familia" />
            <p>Seu familiar responsável é: </p>
          </ContentTitle>
          <hr aria-hidden />
          <ContentInfo>
            <AvatarPic
              aria-hidden
              src={info.responsiblePhotoURL}
              alt="avatar do responsavel"
            />
            <div>
              <p>{info.responsibleName}</p>
              <DisplayEmail>{info.responsibleEmail}</DisplayEmail>
            </div>
          </ContentInfo>
        </Content>
      </Box>
    </>
  );
}
